const AlertModal = ({
  isOpen,
  onClose,
  title,
  message,
  onConfirm,
  onSuccessOneButton,
  isOneButton,
  isSuccess = false,
  isDefault = false,
  isQrSelected,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg w-[calc(100vw-4rem)] max-w-md">
        <div className="relative p-4 md:p-5 text-center">
          {/* <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            <svg
              className="w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1 1l12 12M13 1L1 13"
              />
            </svg>
          </button> */}

          {isDefault ? (
            <svg
              className="mx-auto mb-4 text-gray-500 w-12 h-12"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 11V6m0 8h.01M19 10a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ) : isSuccess ? (
            <svg
              className="mx-auto mb-4 w-12 h-12 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : isQrSelected ? (
            <img
              src="/logos/DuitNow_QR_Logo.png"
              className="w-16 mx-auto mb-4"
              alt="DuitNow QR Logo"
            ></img>
          ) : (
            <svg
              className="mx-auto mb-4 w-12 h-12 text-red-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}

          <h3 className="mb-2 text-lg font-semibold text-gray-800">{title}</h3>
          <p className="mb-5 text-sm text-gray-600">{message}</p>
          {isOneButton ? (
            <button
              type="button"
              onClick={onSuccessOneButton}
              className="ml-3 text-sm text-gray-600 border border-gray-300 rounded-lg px-5 py-2.5 hover:bg-gray-100"
            >
              Okay
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={onConfirm}
                className="text-white bg-red-600 hover:bg-red-700 font-medium rounded-lg text-sm px-5 py-2.5"
              >
                Yes, I'm sure
              </button>
              <button
                type="button"
                onClick={onClose}
                className="ml-3 text-sm text-gray-600 border border-gray-300 rounded-lg px-5 py-2.5 hover:bg-gray-100"
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
